export default __webpack_public_path__ + "static/media/ben.2a46c4bf.jpg";